import "babel-polyfill";
import "./libs/slick"
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {fullHeightPage} from "./modules/fullHeightPage";
import {mainNav} from "./modules/mainNav";
import {headerSticky} from "./modules/headerSticky";
import {videoHolder} from "./modules/videoHolder";
import {scrollToTop} from "./modules/scrollToTop";
import {stickySharing} from "./modules/stickySharing";
import {customSelect} from "./modules/customSelect";
import {anchorLinksClick} from "./modules/anchor-links";
import {categoryTypesSlider} from "./modules/categoryTypesSlider";
import {cookieInfo} from "./modules/cookieInfo";
import {articleListHover} from "./modules/articleListHover";


binder({
    bounds: {
        "html": [constants,fullHeightPage],
        ".header": [mainNav, headerSticky],
        ".video-holder": videoHolder,
        ".scroll-top": scrollToTop,
        ".social-sharing": stickySharing,
        "select": customSelect,
        ".anchor-link": anchorLinksClick,
        ".category-types-slider": categoryTypesSlider,
        ".cookies-holder": cookieInfo,
        ".article-list": articleListHover
    },
    runTests: false
});

window.initCustomSelect = function () {
    customSelect();
};



// WEBPACK FOOTER //
// ./assets/js/global.js